// BannerForm.js
import React, { useState, useEffect } from 'react';
import { Form, Button } from 'react-bootstrap';

const BannerForm = () => {
  // State to manage form data
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    service: "",
    message: "",
  });

  // Set service dynamically based on the page title
  useEffect(() => {
    const service = document.title; // Get page title and set as service
    setFormData((prevData) => ({
      ...prevData,
      service: service,
    }));
  }, []);

  // Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  // Handle form submit
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch('http://localhost:4000/submit-form', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData), // Send the form data as a JSON string
      });

      if (response.ok) {
        alert('Message sent successfully!');
        // Reset form
        setFormData({
          name: "",
          phone: "",
          email: "",
          service: formData.service, // Retain service name after form reset
          message: "",
        });
      } else {
        alert('Failed to send message.');
      }
    } catch (error) {
      console.error('Error submitting the form:', error);
      alert('There was an error submitting your form.');
    }
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Form.Group controlId="name" className="mb-3">
        <Form.Control
          type="text"
          name="name"
          value={formData.name}
          onChange={handleChange}
          placeholder="Enter your name"
          required
        />
      </Form.Group>

      <Form.Group controlId="phone" className="mb-3">
        <Form.Control
          type="tel"
          name="phone"
          value={formData.phone}
          onChange={handleChange}
          placeholder="Enter your phone number"
          required
        />
      </Form.Group>

      <Form.Group controlId="email" className="mb-3">
        <Form.Control
          type="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          placeholder="Enter your email"
          required
        />
      </Form.Group>

      <Form.Group controlId="service" className="mb-3">
        <Form.Control
          type="text"
          name="service"
          value={formData.service}
          readOnly
        />
      </Form.Group>

      <Form.Group controlId="message" className="mb-3">
        <Form.Control
          as="textarea"
          name="message"
          value={formData.message}
          onChange={handleChange}
          rows={3}
          placeholder="Enter your message"
          required
        />
      </Form.Group>

      <Button variant="primary" type="submit" className="w-100">
        Send Message
      </Button>
    </Form>
  );
};

export default BannerForm;
